import { MenuItem as BaseMenuItem, Select as BaseSelect, styled } from "@mui/material";

export const MenuItem = styled(BaseMenuItem)(({ theme }) => ({
  fontSize: theme.typography.size.small,
  "& .MuiCheckbox-root": {
    padding: 0,
  },
  "& svg": {
    marginRight: 4,
    fontSize: 18,
  },
  "&.Mui-selected": {
    backgroundColor: theme.palette.common.white,
  },
  "& .MuiListItemText-primary": {
    fontSize: theme.typography.size.small,
    lineHeight: theme.typography.size.small,
  },
}));

export const Select = styled(BaseSelect)(({ theme }) => ({
  color: "primary",
  fontSize: theme.typography.size.xsmall,
  fontWeight: 500,
  padding: 0,
  "& .MuiInputBase-input": {
    padding: "3px 6px",
  },
}));
